import React, { useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCatalogContext } from '../../contexts/CatalogContext';
import { textToSlug } from '../../utils/slugUtils';

const SearchInput = ({ placeholder = "Buscar producto", className = "" }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { searchTerm, updateSearch } = useCatalogContext();
    const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm || '');

    // Sincronizar con el estado global
    useEffect(() => {
        setLocalSearchTerm(searchTerm || '');
    }, [searchTerm]);

    // Debounce para la búsqueda (solo cuando estamos en la página de catálogo)
    useEffect(() => {
        // Solo aplicar debounce si estamos en la página de catálogo
        if (location.pathname.startsWith('/catalogo')) {
            const timeoutId = setTimeout(() => {
                if (localSearchTerm !== searchTerm) {
                    updateSearch(localSearchTerm);
                }
            }, 500); // 500ms de debounce

            return () => clearTimeout(timeoutId);
        }
    }, [localSearchTerm, searchTerm, updateSearch, location.pathname]);

    const handleInputChange = (e) => {
        setLocalSearchTerm(e.target.value);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    const handleSearch = () => {
        const term = localSearchTerm.trim();
        if (term) {
            // Si estamos en la página de catálogo, usar el contexto
            if (location.pathname.startsWith('/catalogo')) {
                updateSearch(term);
            } else {
                // Si estamos en otra página, redirigir a /catalogo con parámetro filtro (slug) y recargar
                const slug = textToSlug(term);
                const url = `/catalogo?filtro=${encodeURIComponent(slug)}`;
                window.location.assign(url);
            }
        }
    };

    return (
        <span className="p-input-icon-left w-full">
            <i className="pi pi-search text-600 ml-2 text-primary"></i>
            <InputText 
                type="text" 
                placeholder={placeholder}
                className={`surface-section pl-5 surface-border w-full ${className}`}
                value={localSearchTerm}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
            />
        </span>
    );
};

export default SearchInput;
